import React from "react";
import { APITesting } from "../../components/APITesting";

const APITestingPage = () => {
    return (
        <div className="api-testing-page">
            <APITesting />
        </div>
    );
};

export default APITestingPage;
